import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHorizontalPump = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 155.27,
	height: 111.77,
	viewBox: "0 0 155.27 111.77",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 8.5 15.0 A 20.0 20.0 0.0 0 1 38.5 15.0 L 38.5 105.0 A 20.0 20.0 0.0 0 1 8.5 105.0 Z M 148.5 45.0 A 20.0 20.0 0.0 0 1 148.5 75.0 L 58.5 75.0 A 20.0 20.0 0.0 0 1 58.5 45.0 Z M 58.5 45.0 L 58.5 75.0 M 148.5 45.0 L 148.5 75.0 M 23.5 8.5 L 23.5 0.0 M 13.5 0.0 L 33.5 0.0 M 0.0 60.0 L 8.5 60.0 M 0.0 50.0 L 0.0 70.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 38.5,
		y: 58,
		width: 13.5,
		height: 4,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgHorizontalPump;
